import React from 'react';
import { Stack } from '@mui/material';

import { Button } from './Button';

import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from '../icons';

export interface IPaginationProps {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  requestNextPage: () => void;
  requestPreviousPage: () => void;
}

export const Pagination: React.FC<IPaginationProps> = (props) => {
  const { hasNextPage, hasPreviousPage, requestPreviousPage, requestNextPage } = props;

  return (
    <Stack
      direction='row'
      alignItems='center'
      ml={2}
      justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
      spacing={1}
      minHeight={52}
      pr={2}
    >
      <Button
        size='small'
        startIcon={<KeyboardArrowLeftIcon />}
        onClick={requestPreviousPage}
        disabled={!hasPreviousPage}
      >
        prev
      </Button>
      <Button
        size='small'
        endIcon={<KeyboardArrowRightIcon />}
        onClick={requestNextPage}
        disabled={!hasNextPage}
      >
        next
      </Button>
    </Stack>
  );
};
